import { render, staticRenderFns } from "./ConfigPasswordDialog.vue?vue&type=template&id=04756956&scoped=true"
import script from "./ConfigPasswordDialog.vue?vue&type=script&lang=js"
export * from "./ConfigPasswordDialog.vue?vue&type=script&lang=js"
import style0 from "./ConfigPasswordDialog.vue?vue&type=style&index=0&id=04756956&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04756956",
  null
  
)

export default component.exports